(function () {
  const initMobileMenu = (footer) => {
    footer.querySelectorAll(".js-accordion-mobile").forEach((details) => {
      const summary = details.querySelector(".footer__nav-heading");
      const content = details.querySelector(".footer__nav-content");
      let isAnimating = false;

      if (!summary || !content) return;

      summary.addEventListener("click", (event) => {
        if (window.innerWidth >= 990 || isAnimating) {
          return;
        }

        event.preventDefault();

        isAnimating = true;

        if (!details.getAttribute("open")) {
          const contentHeight = content.scrollHeight;
          content.style.setProperty(
            "--footer-menu-max-height",
            `${contentHeight}px`
          );

          details.setAttribute("open", true);

          content.addEventListener(
            "transitionend",
            () => {
              isAnimating = false;
            },
            { once: true }
          );
        } else {
          details.removeAttribute("open");

          content.addEventListener(
            "transitionend",
            () => {
              isAnimating = false;
            },
            { once: true }
          );
        }
      });
    });
  };

  const initFooter = () => {
    const footer = document.querySelector(".shopify-section-footer");
    if (!footer) return;

    initMobileMenu(footer);
  };

  initFooter();

  document.addEventListener("shopify:section:load", initFooter);
  document.addEventListener("shopify:section:unload", initFooter);
  document.addEventListener("shopify:section:reorder", initFooter);
})();
